import React from 'react';
import AttachmentContent from "./attachment-content.jsx";

const CreateContent = ({element}) => {
    const createData = JSON.parse(element?.new ?? "{}");

    return (
        <tr className="create-content-table">
            <td colSpan={14}>
                <table className="applied insider w-full">
                    <thead>
                        <tr className='text-left'>
                            <th style={{width: "30%"}}>Campo</th>
                            <th style={{width: "70%"}}>Novo</th>
                        </tr>
                    </thead>

                    <tbody>
                        {Object.entries(createData).map(([key, value], index) => {

                            if (key === "attendance_attachment") {
                                return (
                                    <AttachmentContent key={index} attachments={Object.values(value)}/>
                                );
                            }

                            return (
                                <tr key={index} className="text-left">
                                    <td>{key}</td>
                                    <td className={'break-all! whitespace-normal'}>{value}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default CreateContent;